import styled, { keyframes } from 'styled-components'
import { StandardCard } from '@navinc/base-react-components'

const borderWidth = '8px'
const loaderSize = '48px'

const StyledCard = styled(StandardCard)`
  grid-column: span 12;
`

const LoaderNode = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 128px auto;
  min-width: ${loaderSize};
  min-height: ${loaderSize};
  flex-flow: row nowrap;
  width: 100%;
  justify-content: center;
`

const Spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

export const Spinner = styled.div`
  border-radius: 50%;
  width: ${loaderSize};
  height: ${loaderSize};
  margin-right: 16px;
  border: ${borderWidth} solid ${({ theme }) => theme.navPrimary200};
  border-left: ${borderWidth} solid ${({ theme }) => theme.navPrimary};
  border: ${borderWidth} solid ${({ theme }) => `${theme.navPrimary}22`}; /* stylelint-disable-line declaration-block-no-duplicate-properties  */
  border-left: ${borderWidth} solid ${({ theme }) => `${theme.navPrimary}bb`}; /* stylelint-disable-line declaration-block-no-duplicate-properties  */
  transform: translateZ(0);
  animation: ${Spin} 0.88s infinite linear;
`

export const Loader = ({ label, className }) => (
  <StyledCard className={className} data-testid="loader-card">
    <LoaderNode>
      <Spinner />
      <h2>{label || 'Loading...'}</h2>
    </LoaderNode>
  </StyledCard>
)

export const LoadingContent = ({ children, isLoading, className, label = 'Loading' }) =>
  isLoading ? <Loader className={className} label={label} /> : children
